import type { TypographyVariantsOptions } from '@mui/material/styles';

const FONT_STACK = '"Inter Variable", "Inter", "Segoe UI", system-ui, -apple-system, sans-serif';

export const typography: TypographyVariantsOptions = {
  fontFamily: FONT_STACK,
  fontSize: 14,
  h1: { fontSize: '1.75rem', fontWeight: 600, lineHeight: 1.2, letterSpacing: '-0.02em' },
  h2: { fontSize: '1.375rem', fontWeight: 600, lineHeight: 1.3, letterSpacing: '-0.01em' },
  h3: { fontSize: '1.0625rem', fontWeight: 600, lineHeight: 1.4 },
  h4: { fontSize: '0.9375rem', fontWeight: 600, lineHeight: 1.4 },
  subtitle1: { fontSize: '0.9375rem', fontWeight: 500, lineHeight: 1.45 },
  subtitle2: { fontSize: '0.8125rem', fontWeight: 600, lineHeight: 1.45 },
  body1: { fontSize: '0.9375rem', lineHeight: 1.6 },
  body2: { fontSize: '0.8125rem', lineHeight: 1.55 },
  caption: { fontSize: '0.75rem', lineHeight: 1.45 },
  overline: { fontSize: '0.6875rem', fontWeight: 600, lineHeight: 1.6, letterSpacing: '0.08em' },
  button: { textTransform: 'none', fontWeight: 500, letterSpacing: 0 },
};
